import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from '@chakra-ui/react';
import { FC, useState } from 'react';

export enum IssueType {
  FOLDER = 'FOLDER',
  DOCUMENT = 'DOCUMENT',
}

interface AddIssueModalProps {
  isOpen: boolean;
  onClose: () => void;
  issueType: IssueType;
  onSubmit: (issueData: IssueFormData) => void | Promise<void>;
  isLoading?: boolean;
}

export interface IssueFormData {
  message: string;
}

export const AddIssueModal: FC<AddIssueModalProps> = ({
  isOpen,
  onClose,
  issueType,
  onSubmit,
  isLoading = false,
}) => {
  const [formData, setFormData] = useState<IssueFormData>({
    message: '',
  });

  const handleSubmit = async () => {
    await onSubmit(formData);
    handleClose();
  };

  const handleClose = () => {
    setFormData({
      message: '',
    });
    onClose();
  };

  const modalTitle =
    issueType === IssueType.FOLDER ? 'Add Folder Issue' : 'Add Document Issue';

  return (
    <Modal isOpen={isOpen} size="md" onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>Message</FormLabel>
            <Textarea
              placeholder={`Describe the ${issueType.toLowerCase()} issue...`}
              value={formData.message}
              onChange={(e) =>
                setFormData({ ...formData, message: e.target.value })
              }
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} variant="ghost" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            isDisabled={!formData.message.trim()}
            isLoading={isLoading}
            onClick={() => void handleSubmit()}
          >
            Add Issue
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
